import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { css as innerCss } from '@emotion/react';
export * from '@emotion/react';
export function css(template) { for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
} return /*#__PURE__*/ innerCss.apply(void 0, [template].concat(_toConsumableArray(args.map(function (interpolation) { if (typeof interpolation === "function") {
    return interpolation();
} return interpolation; })))); }
